var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"zhanwei"}),_c('div',{staticClass:"logobox"},[_c('img',{staticClass:"logoimg",attrs:{"src":require("@/assets/imgs/logo@3x.png"),"alt":""},on:{"click":function($event){return _vm.changeCategory()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }